import { memo } from 'react'

import { T } from 'govwell-ui'

import { highlightSearchQueryInPlainText } from 'src/components/UniversalSearchModal/highlightSearchQueryInPlainText'

type Props = {
  bodyText: string
  searchQuery: string
}

/** Shared body for universal search condition rows (active conditions only; highlighted text). */
const UniversalSearchConditionResultBody = ({ bodyText, searchQuery }: Props) => {
  return <T.Body>{highlightSearchQueryInPlainText(bodyText, searchQuery)}</T.Body>
}

export default memo(UniversalSearchConditionResultBody)
